// A random opaque id, used for client-minted idempotency/correlation keys.
// `crypto.randomUUID` needs a secure context + a recent engine (Safari 15.4+);
// the fallback keeps the app working on http origins and older WebKit (the
// Safari-14 floor) without pulling in a uuid dependency. Same guard as
// `useWsSession`'s `mintMsgId`.
export const randomId = (): string =>
  typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
    ? crypto.randomUUID()
    : `r${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
